// import * as THREE from 'https://unpkg.com/three@0.126.1/build/three.module.js';
// import { OrbitControls } from 'https://unpkg.com/three@0.126.1/examples/jsm/controls/OrbitControls';
// import { GLTFLoader } from 'https://unpkg.com/three@0.126.1/examples/jsm/loaders/GLTFLoader.js';
// import { EffectComposer } from 'https://unpkg.com/three@0.126.1/examples/jsm/postprocessing/EffectComposer.js';
// import { RenderPass } from 'https://unpkg.com/three@0.126.1/examples/jsm/postprocessing/RenderPass.js';
// import { UnrealBloomPass } from 'https://unpkg.com/three@0.126.1/examples/jsm/postprocessing/UnrealBloomPass.js';
// import { GlitchPass } from 'https://unpkg.com/three@0.126.1/examples/jsm/postprocessing/GlitchPass.js';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
import { GlitchPass } from 'three/examples/jsm/postprocessing/GlitchPass.js';
import { RoundedBoxGeometry } from 'three/examples/jsm/geometries/RoundedBoxGeometry.js';

var pointLight1Colour = "#FF4447";
var pointLight2Colour = "#6C51FF";
var pointLight3Colour = "#65A5FF";

const nameModel = new URL('../models/Name.glb', import.meta.url);
const part = new URL('../images/CircleGlow1.png', import.meta.url);

let mouseX = 0, mouseY = 0;

const scene = new THREE.Scene();
const renderer = new THREE.WebGLRenderer();
const camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.1, 1000);
const composer = new EffectComposer(renderer);
const renderPass = new RenderPass(scene, camera);

composer.setSize(window.innerWidth, window.innerHeight);
composer.addPass(renderPass);

const unrealBloomPass = new UnrealBloomPass(new THREE.Vector2(window.innerWidth/2, window.innerHeight/2), 1, 1.2, 0.1);
composer.addPass(unrealBloomPass);

const glitchPass = new GlitchPass();
// composer.addPass(glitchPass);

renderer.setSize(window.innerWidth, window.innerHeight);

document.body.appendChild(renderer.domElement);

// renderer.gammaInput = true;
// renderer.gammaOutput = true;

camera.position.set(2.8, 1.6, 4.4); //3.4
camera.rotation.x = -0.5;
camera.rotation.y = 0.6;
camera.rotation.z = 0.3;

// camera.lookAt(scene.position);
// camera.Euler = new THREE.Vector3(-0.5, 0.6, 0.3);
// camera.setRotationFromEuler(new THREE.Euler(-0.4679161027466852, 0.7071859841223206, 0.3172340871552861));
// camera.setRotationFromEuler(new THREE.Euler(-0.6185777967159405, 0.6917330930106341, 0.4261878040407827));
// camera.setRotationFromEuler(new THREE.Euler(-0.5, 0.6, 0.3));

//#region Spheres:
//Sphere1:
const sphere1Geometry = new THREE.SphereGeometry(1.068, 20, 20);
// const sphere1Geometry = new RoundedBoxGeometry(1.68, 1.68, 1.68, 1, 0.1);
const sphere1Material = new THREE.MeshPhysicalMaterial({
    color: "white",
    clearcoat: 1
});
const sphere1 = new THREE.Mesh(sphere1Geometry, sphere1Material)
sphere1.position.set(-3.38227, -1.52642, 1.06636);
sphere1.rotation.set(-3.38227, -1.52642, 1.06636);
scene.add(sphere1);

//Sphere2:
const sphere2Geometry = new THREE.SphereGeometry(1.266, 20, 20);
// const sphere2Geometry = new RoundedBoxGeometry(1.68, 1.68, 1.68, 1, 0.1);
const sphere2Material = new THREE.MeshPhysicalMaterial({
    color: "white",
    clearcoat: 1
});
const sphere2 = new THREE.Mesh(sphere2Geometry, sphere2Material)
sphere2.position.set(0.11412, 4.76156, 0.472766);
sphere2.rotation.set(0.11412, 4.76156, 0.472766);
scene.add(sphere2);

//Sphere3:
const sphere3Geometry = new THREE.SphereGeometry(0.75, 20, 20);
// const sphere3Geometry = new RoundedBoxGeometry(1, 1, 1, 1, 0.1);
const sphere3Material = new THREE.MeshPhysicalMaterial({
    color: "white",
    clearcoat: 1
});
const sphere3 = new THREE.Mesh(sphere3Geometry, sphere3Material)
sphere3.position.set(-1.75799, -2.89334, -1.41839);
sphere3.rotation.set(-1.75799, -2.89334, -1.41839);
scene.add(sphere3);

//Sphere4:
const sphere4Geometry = new THREE.SphereGeometry(1.37, 20, 20);
// const sphere4Geometry = new RoundedBoxGeometry(2.37, 2.37, 2.37, 1, 0.1);
const sphere4Material = new THREE.MeshPhysicalMaterial({
    color: "white",
    clearcoat: 1
});
const sphere4 = new THREE.Mesh(sphere4Geometry, sphere4Material);
sphere4.position.set(-3.92841, 0.309595, -0.719632);
sphere4.rotation.set(-3.92841, 0.309595, -0.719632);
scene.add(sphere4);

//Sphere5:
const sphere5Geometry = new THREE.SphereGeometry(2.41, 20, 20);
// const sphere5Geometry = new RoundedBoxGeometry(3, 3, 3, 1, 0.1);
const sphere5Material = new THREE.MeshPhysicalMaterial({
    color: "white",
    clearcoat: 1
});
const sphere5 = new THREE.Mesh(sphere5Geometry, sphere5Material);
sphere5.position.set(1.51147, 3.78743, -3.37931);
sphere5.rotation.set(1.51147, 3.78743, -3.37931);
scene.add(sphere5);

//Sphere6:
const sphere6Geometry = new THREE.SphereGeometry(0.47, 20, 20);
// const sphere6Geometry = new RoundedBoxGeometry(0.87, 0.87, 0.87, 1, 0.1);
const sphere6Material = new THREE.MeshPhysicalMaterial({
    color: "white",
    clearcoat: 1
});
const sphere6 = new THREE.Mesh(sphere6Geometry, sphere6Material)
sphere6.position.set(-1.00009, 0.5812, 0.025969);
sphere6.rotation.set(-1.00009, 0.5812, 0.025969);
scene.add(sphere6);

//Sphere7:
const sphere7Geometry = new THREE.SphereGeometry(0.388, 20, 20);
// const sphere7Geometry = new RoundedBoxGeometry(1.3, 1.3, 1.3, 1, 0.1);
const sphere7Material = new THREE.MeshPhysicalMaterial({
    color: "white",
    clearcoat: 1
});
const sphere7 = new THREE.Mesh(sphere7Geometry, sphere7Material)
sphere7.position.set(-0.966533, -1.50039, -0.655202);
sphere7.rotation.set(-0.966533, -1.50039, -0.655202);
scene.add(sphere7);

//Sphere8:
const sphere8Geometry = new THREE.SphereGeometry(0.727, 20, 20);
// const sphere8Geometry = new RoundedBoxGeometry(1, 1, 1, 1, 0.1);
const sphere8Material = new THREE.MeshPhysicalMaterial({
    color: "white",
    clearcoat: 1
});
const sphere8 = new THREE.Mesh(sphere8Geometry, sphere8Material)
sphere8.position.set(-1.02627, 2.98227, 0.372736);
sphere8.rotation.set(-1.02627, 2.98227, 0.372736);
scene.add(sphere8);

//Sphere9:
const sphere9Geometry = new THREE.SphereGeometry(0.985, 20, 20);
// const sphere9Geometry = new RoundedBoxGeometry(1.7, 1.7, 1.7, 1, 0.1);
const sphere9Material = new THREE.MeshPhysicalMaterial({
    color: "white",
    clearcoat: 1
});
const sphere9 = new THREE.Mesh(sphere9Geometry, sphere9Material)
sphere9.position.set(1, -0.74016, -1.47878);
sphere9.rotation.set(1, -0.74016, -1.47878);
scene.add(sphere9);

//Sphere10:
const sphere10Geometry = new THREE.SphereGeometry(0.804, 20, 20);
// const sphere10Geometry = new RoundedBoxGeometry(1.85, 1.85, 1.85, 1, 0.1);
const sphere10Material = new THREE.MeshPhysicalMaterial({
    color: "white",
    clearcoat: 1
});
const sphere10 = new THREE.Mesh(sphere10Geometry, sphere10Material)
// sphere10.position.set(0.749209, -0.499924, 2.56901);
sphere10.position.set(1.749209, -1, 2);
sphere10.rotation.set(1.749209, -1, 2);
scene.add(sphere10);
//#endregion

const orbitControls = new OrbitControls(camera, renderer.domElement);

orbitControls.enabled = false;
orbitControls.update();

const pointLight = new THREE.PointLight(pointLight1Colour, 0.1);
scene.add(pointLight);
pointLight.castShadow = true;
pointLight.position.set(-5.4186, 2, 2.10586);

const pointLight1 = new THREE.PointLight(pointLight2Colour, 0.1);
scene.add(pointLight1);
pointLight1.castShadow = true;
pointLight1.position.set(3.69341, 1.61534, 2.1025);

const pointLight2 = new THREE.PointLight(pointLight3Colour, 0.1);
scene.add(pointLight2);
pointLight2.castShadow = true;
pointLight2.position.set(0.784376, -4.14464, 1.79634);

const nameLight = new THREE.PointLight("#FF6ADE", 0.1);
scene.add(nameLight);

const gltfLoader = new GLTFLoader();

gltfLoader.load(nameModel.href, function(gltf) {
    scene.add(gltf.scene);

    for (var i = 0; i < gltf.scene.children.length; i++) {
        let material = new THREE.MeshPhysicalMaterial({
            color: "white",
            emissive: "#ff62ef",
            // emissive: "#ffabf7",
            emissiveIntensity: 1.5
        });
        
        gltf.scene.children[i].castShadow = false;
        gltf.scene.children[i].receiveShadow = false;
        gltf.scene.children[i].scale.set(0.6, 0.6, 0.6);
        gltf.scene.children[i].material = material;
    }
});

let windowHalfX = window.innerWidth / 2;
let windowHalfY = window.innerHeight / 2;

window.addEventListener('resize', (event) => {
    windowHalfX = window.innerWidth / 2;
    windowHalfY = window.innerHeight / 2;

    renderer.setSize(window.innerWidth, window.innerHeight);
    composer.setSize(window.innerWidth, window.innerHeight);
    camera.aspect = window.innerWidth / window.innerHeight;

    camera.updateProjectionMatrix();
}, true);

document.addEventListener('pointermove', (event) => {
    if ( event.isPrimary === false ) return;

    //#region Old Background Movement Code:
    // let scale = -0.002;
    // camera.position.x = Math.sin(camera.position.x + (event.movementX * scale) * -2.5);
    // camera.position.y = camera.position.y + (event.movementY * scale); 
    // camera.position.z = camera.position.z;

    // camera.lookAt(new THREE.Vector3(event.clientX * -0.001, event.clientY * -0.001, camera.rotation.z));

    // pointer.x = ( event.clientX / window.innerWidth ) * 2 - 1;
	// pointer.y = - ( event.clientY / window.innerHeight ) * 2 + 1;
    //#endregion

    //#region New Background Movement Code:
    mouseX = event.clientX - (windowHalfX / 2);
    mouseY = event.clientY - windowHalfY;
    //#endregion
});

var navigationButtons = document.getElementsByClassName("nav-button");

for (var i = 0; i < navigationButtons.length; i++) {
    navigationButtons[i].addEventListener("click", (event) => {
        triggerGlitch();
    });
}

var closeButtons = document.getElementsByClassName("close");

for (var i = 0; i < closeButtons.length; i++) {
    closeButtons[i].addEventListener("click", (event) => {
        triggerGlitch();
    });
}

var portfolioButtons = document.getElementsByClassName("portfolio-button");

for (var i = 0; i < portfolioButtons.length; i++) {
    portfolioButtons[i].addEventListener("click", (event) => {
        triggerGlitch();
    });
}

document.getElementById("about-contact").addEventListener("click", (event) => {
    triggerGlitch();
});

export function triggerGlitch() {
    composer.addPass(glitchPass);
    glitchPass.curF = 0;
    glitchPass.goWild = false;
    glitchPass.generateTrigger();
    setTimeout(removeGlitch, 1500);
}

function removeGlitch() {
    composer.removePass(glitchPass);
}

//#region Particles:
const vertices = [];
const vertices2 = [];
const geometry = new THREE.BufferGeometry();
const geometry2 = new THREE.BufferGeometry();

for (let i = 0; i < 1000; i ++) {
    const x = 20 * Math.random() - 10;
    const y = 20 * Math.random() - 10;
    const z = 20 * Math.random() - 10;

    vertices.push(x, y, z);
}

for (let i = 0; i < 1000; i ++) {
    const x = 20 * Math.random() - 10;
    const y = 20 * Math.random() - 10;
    const z = 20 * Math.random() - 10;

    vertices2.push(x, y, z);
}

geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
geometry2.setAttribute('position', new THREE.Float32BufferAttribute(vertices2, 3));

let material = new THREE.PointsMaterial({
    size: 0.2, 
    // size: 0.05, 
    sizeAttenuation: true,
    map: new THREE.TextureLoader().load(part.href),
    transparent: true
});
material.color.setHSL( 1.0, 0.3, 0.7);

const particles = new THREE.Points(geometry, material);
const particles2 = new THREE.Points(geometry2, material);
scene.add(particles);
scene.add(particles2);
//#endregion

document.getElementById("contact-form").addEventListener("submit", (event) => {
    triggerGlitch();  
});

document.getElementById("submitting-acknowledge").addEventListener("click", (event) => {
    triggerGlitch();  
});

function animate() {
    particles.rotation.x += 0.0003;
    particles.rotation.z += 0.0003;
    particles2.rotation.x -= 0.0005;
    particles2.rotation.z -= 0.0006;

    // renderer.render(scene, camera);
    composer.render();
    requestAnimationFrame(animate);
    
    camera.position.x = (mouseX - camera.position.x) * 0.003;
    camera.position.y = (-mouseY - camera.position.y) * 0.003;
    
    camera.lookAt(scene.position);
}

animate();